/* Fuego & Fragancia — Pack de Sales de Baño.
 *
 * Escalones por cantidad + selector de aromas. El descuento REAL lo aplica un
 * descuento automatico de Shopify Admin; aqui solo se calcula lo mismo que va
 * a cobrar el checkout, para que la cifra que ve el cliente sea la de verdad.
 *
 * REGLA DE REDONDEO (verificada con draftOrderCalculate, no supuesta):
 * Shopify trunca hacia abajo el descuento de CADA LINEA de pedido.
 *   3 sales distintas @10%  -> 3 lineas x floor(3535*10/100)=353  -> 95.46
 *   3 sales iguales   @10%  -> 1 linea  x floor(10605*10/100)=1060 -> 95.45
 * Por eso el total se suma linea por linea y no sobre el subtotal.
 */

if (!customElements.get('ff-salt-bundle')) {
  customElements.define(
    'ff-salt-bundle',
    class FfSaltBundle extends HTMLElement {
      connectedCallback() {
        this.radios = Array.from(this.querySelectorAll('.ff-salt-bundle__radio'));
        this.salts = Array.from(this.querySelectorAll('[data-ff-salt]'));
        this.counterEl = this.querySelector('[data-ff-salt-counter]');
        this.totalEl = this.querySelector('[data-ff-salt-total]');
        this.compareEl = this.querySelector('[data-ff-salt-compare]');
        this.savedEl = this.querySelector('[data-ff-salt-saved]');
        this.errorEl = this.querySelector('[data-ff-salt-error]');
        this.submitEl = this.querySelector('[data-ff-salt-submit]');
        this.ctaTextEl = this.querySelector('[data-ff-salt-cta-text]');

        this.tplCta = this.dataset.cta || 'ADD TO CART';
        this.tplCtaNeed = this.dataset.ctaNeed || 'PICK [n] MORE';
        this.tplCount = this.dataset.count || '[n] of [max] chosen';
        this.tplSavings = this.dataset.savings || 'You save [amount]';

        // Lista con repeticiones, en orden de eleccion. El orden importa: al
        // estar lleno, elegir un aroma nuevo sustituye al MAS ANTIGUO, para
        // que nunca haya un callejon sin salida (sobre todo en el escalon 1x).
        this.picks = [];

        this.radios.forEach((radio) => {
          radio.addEventListener('change', () => this.onTierChange());
        });

        this.salts.forEach((salt) => {
          const add = salt.querySelector('[data-ff-salt-add]');
          const remove = salt.querySelector('[data-ff-salt-remove]');
          const id = salt.dataset.variantId;

          if (add) add.addEventListener('click', () => this.add(id));
          if (remove) remove.addEventListener('click', () => this.remove(id));
        });

        if (this.submitEl) {
          this.submitEl.addEventListener('click', () => this.addToCart());
        }

        // Si ningun bloque venia marcado como preseleccionado, el primero.
        if (this.radios.length && !this.radios.some((r) => r.checked)) {
          this.radios[0].checked = true;
        }

        // En una ficha de producto, la pieza que se esta viendo entra ya
        // elegida: el cliente no deberia tener que volver a marcarla. Se
        // comprueba que exista entre las tarjetas antes de darla por buena
        // (el producto puede no estar en la coleccion de origen).
        const inicial = this.dataset.preselect || '';
        if (inicial && this.salts.some((s) => s.dataset.variantId === inicial)) {
          this.picks.push(inicial);
        }

        this.render();
      }

      get target() {
        const checked = this.radios.find((r) => r.checked);
        return checked ? parseInt(checked.value, 10) || 1 : 1;
      }

      get pct() {
        const checked = this.radios.find((r) => r.checked);
        return checked ? parseInt(checked.dataset.pct, 10) || 0 : 0;
      }

      onTierChange() {
        // Bajar de escalon no puede dejar mas sales elegidas que el tope.
        while (this.picks.length > this.target) this.picks.shift();
        this.render();
      }

      add(id) {
        if (this.picks.length >= this.target) {
          // Lleno: solo sustituye si el aroma es nuevo.
          if (this.picks.indexOf(id) !== -1) return;
          this.picks.shift();
        }
        this.picks.push(id);
        this.render();
      }

      remove(id) {
        const i = this.picks.indexOf(id);
        if (i !== -1) this.picks.splice(i, 1);
        this.render();
      }

      money(cents) {
        if (window.ffMoney) return window.ffMoney(cents);
        return '$' + (cents / 100).toFixed(2);
      }

      /* Agrupa por variante -> una linea de pedido por aroma, igual que hara
         el carrito, y aplica el truncado por linea. */
      lines() {
        const byVariant = new Map();

        this.picks.forEach((id) => {
          const salt = this.salts.find((s) => s.dataset.variantId === id);
          if (!salt) return;
          const price = parseInt(salt.dataset.price, 10) || 0;
          const line = byVariant.get(id) || { id: id, price: price, qty: 0 };
          line.qty += 1;
          byVariant.set(id, line);
        });

        return Array.from(byVariant.values());
      }

      totals() {
        const pct = this.pct;
        let full = 0;
        let discounted = 0;

        this.lines().forEach((line) => {
          const lineTotal = line.price * line.qty;
          const off = Math.floor((lineTotal * pct) / 100);
          full += lineTotal;
          discounted += lineTotal - off;
        });

        return { full: full, discounted: discounted, saved: full - discounted };
      }

      render() {
        const target = this.target;
        const chosen = this.picks.length;
        const missing = target - chosen;
        const complete = missing === 0;
        const sums = this.totals();

        this.salts.forEach((salt) => {
          const id = salt.dataset.variantId;
          const n = this.picks.filter((p) => p === id).length;
          const countEl = salt.querySelector('[data-ff-salt-count]');
          const removeEl = salt.querySelector('[data-ff-salt-remove]');

          salt.classList.toggle('is-picked', n > 0);
          // Atenuado solo cuando esta lleno Y este aroma ya no puede sumar.
          salt.classList.toggle('is-full', chosen >= target && n > 0);

          if (countEl) {
            countEl.textContent = n;
            countEl.hidden = n === 0;
          }
          if (removeEl) removeEl.hidden = n === 0;
        });

        if (this.counterEl) {
          this.counterEl.textContent = this.tplCount
            .replace('[n]', chosen)
            .replace('[max]', target);
          this.counterEl.classList.toggle('is-complete', complete);
        }

        if (this.totalEl) this.totalEl.textContent = this.money(sums.discounted);

        if (this.compareEl) {
          this.compareEl.hidden = sums.saved === 0;
          this.compareEl.textContent = this.money(sums.full);
        }

        if (this.savedEl) {
          this.savedEl.hidden = sums.saved === 0;
          this.savedEl.textContent = this.tplSavings.replace('[amount]', this.money(sums.saved));
        }

        if (this.submitEl) this.submitEl.disabled = !complete;

        if (this.ctaTextEl) {
          this.ctaTextEl.textContent = complete
            ? this.tplCta.replace('[total]', this.money(sums.discounted))
            : this.tplCtaNeed.replace('[n]', missing);
        }
      }

      showError(message) {
        if (!this.errorEl) return;
        this.errorEl.textContent = message;
        this.errorEl.hidden = !message;
      }

      addToCart() {
        const lines = this.lines();
        if (lines.length === 0 || this.picks.length !== this.target) return;

        this.showError('');
        this.submitEl.disabled = true;
        this.submitEl.classList.add('is-loading');

        const cartDrawer = document.querySelector('cart-drawer');
        const body = {
          items: lines.map((line) => ({ id: Number(line.id), quantity: line.qty })),
        };

        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          body.sections = cartDrawer.getSectionsToRender().map((section) => section.id);
          body.sections_url = window.location.pathname;
        }

        fetch(window.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        })
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.showError(response.description || response.message || '');
              return;
            }

            if (cartDrawer) {
              // Igual que product-form.js de Dawn: sin esto la clase is-empty
              // se queda pegada y `cart-drawer.is-empty .drawer__inner`
              // convierte el panel flex en grid y rompe el carrito entero.
              cartDrawer.classList.remove('is-empty');
              cartDrawer.renderContents(response);
            } else {
              window.location = window.routes.cart_url;
            }

            this.picks = [];
          })
          .catch(() => this.showError(''))
          .finally(() => {
            this.submitEl.classList.remove('is-loading');
            this.render();
          });
      }
    }
  );
}
